module.exports = __webpack_public_path__ + "img/icon-arrow-red.245f3fa0.svg";